import { EventEmitter, Injectable, Output, NgZone } from '@angular/core';
import { HttpClient, HttpHeaderResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { AppInformationService } from './appinformation.service';
import { WMAIApiService } from './wmaiapi.service';
import { ExpLocalStorage } from './explocalstorage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as Sentry from '@sentry/browser'
import { TranslateService } from '@ngx-translate/core';
import { ModalSize, SuiModalService } from 'ng2-semantic-ui';
import { SimpleModal } from '../templates/simple-modal.model';

declare var window;
declare var facebookConnectPlugin;
declare var TwitterConnect;
declare var FirebasePlugin;

interface Jwt {
  token: string;
  name: string;
  first_name: string;
  last_name: string;
  userid: string;
  email: string;
  locale: string;
  user_role: string;
  domain: string;
  isactive: string;
  isfirstlogin: string;
  __id: string;
  uuid: string;
  accesstoken: string;
}

export interface EvtSignIn {
  token: string;
  userid: string;
  locale: string;
  email: string;
  isactive: string;
  isfirstlogin: string;
  domain: string;
  accesstoken: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isUserLogged = false;
  private isFirstLogin = false;
  // private isAdmin = false;
  // private isSupervisor = false;
  private iduser: string;

  @Output() usersignedin = new EventEmitter();
  @Output() userislogin = new EventEmitter<EvtSignIn>();
  @Output() usersignedup = new EventEmitter();
  @Output() userlogout = new EventEmitter();
  @Output() usersetlanguage = new EventEmitter();
  @Output() userisfirstlogin = new EventEmitter<boolean>();
  @Output() userisactive = new EventEmitter<boolean>();

  helper = new JwtHelperService();

  constructor(
    private http: HttpClient,
    private appservice: AppInformationService,
    private wmaiservice: WMAIApiService,
    private router: Router,
    private zone: NgZone,
    private expLocal: ExpLocalStorage,
    private activateRoute: ActivatedRoute,
    private translateService: TranslateService,
    private modalService: SuiModalService,
  ) {
    
  }
  /**
   * attraverso il token controlla se l'utente Ã¨ loggato o meno
   */
  isUserLoggedIn() {
    this.isUserLogged = !!localStorage.getItem('token');
    return this.isUserLogged;
  }
  /**
   * ottieni il primo login
   */
  getIsFirstLogin() {
    return this.isFirstLogin;
  }

  /**
   * si setta il local storage attraverso i parametri passati, il tutto va all'interno
   * di un JsonWebToken, cosÃ¬ da richiamare ogni volta che lo si ritiene opportuno per recuperare
   * il token e riottenere l'accesso
   * @param  {string} username
   * @param  {string} password
   */
  signIn(username: string, password: string) {
    this.http.post(environment.wmaiAPIServer + '/admin/login',
      {
        userid: username,
        password
      }, {
      headers:
        { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
    }
    ).subscribe(
      (payload: Jwt) => {
        if(payload.isactive){
          this.completeLogin(payload);
        } else {
          this.zone.run(() => {
            this.showSimpleModal('auth.messages.attention', 'auth.messages.user_not_activate')
          })
        }
      },
      (httpResp: HttpErrorResponse) => {
        alert(httpResp.error.error);
        this.isUserLogged = false;
      },
    );

  }
  /** attraverso i parametri, madati attraverso una post, si settano dei campi che vanno ad
   * inserire elementi all'interno del server
   * @param  {string} email
   * @param  {string} password
   */
  signUp(email: string, password: string): Observable<any> {
    return this.http.post(environment.wmaiAPIServer + '/admin/adduser',
      {
        userid: email,
        password,
        email,
        lastname: '',
        firstname: '',
        name: email
      }, {
      headers:
        { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
    }
    ).pipe(map(response => response));
  }
  /** attraverso un post si va resettare la password
   * @param  {string} email
   * @param  {string} password
   */
  resetPassword(email: string, password: string): Observable<any> {
    return this.http.post(environment.wmaiAPIServer + '/admin/resetPassword',
      {
        userid: email,
        password
      }, {
      headers:
        { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
    }
    ).pipe(map(response => response));
  }
  /**
   * si va a svuotare il local storage di tutti i suoi elementi e si fa un logout
   */
  logout() {
    if (this.appservice.iAmMobile()) {
      this.expLocal.clearCache();
      FirebasePlugin.getToken(token => {
        this.wmaiservice.removeDevice(token).subscribe(data => {
            window.FirebasePlugin.unregister();
            // console.log("fatto");
            localStorage.removeItem('token');
            localStorage.removeItem('email');
            localStorage.removeItem('username');
            localStorage.setItem('id', '-1');
            localStorage.removeItem('role');
            localStorage.removeItem('domain');
            localStorage.removeItem('isfirstlogin');
            localStorage.removeItem('isactive');
            localStorage.removeItem('accesstoken');
            this.isUserLogged = false;
            this.userlogout.emit();
            this.iduser = '-1';
        });
      }, err => {
        Sentry.captureException(err.originalError || err);
        if (localStorage.getItem('domain') === 'spid') { 
          this.spidLogout(localStorage.getItem('accesstoken'));
        }
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('username');
        localStorage.setItem('id', '-1');
        localStorage.removeItem('role');
        localStorage.removeItem('domain');
        localStorage.removeItem('isfirstlogin');
        localStorage.removeItem('isactive');
        localStorage.removeItem('accesstoken');
        this.isUserLogged = false;
        this.userlogout.emit();
        this.iduser = '-1';
      });
      this.socialLogout();
    } else {
      if (localStorage.getItem('domain') === 'spid') { 
        this.spidLogout(localStorage.getItem('accesstoken'));
      }
      localStorage.removeItem('token');
      localStorage.removeItem('email');
      localStorage.removeItem('username');
      localStorage.setItem('id', '-1');
      localStorage.removeItem('role');
      localStorage.removeItem('domain');
      localStorage.removeItem('isfirstlogin');
      localStorage.removeItem('isactive');
      localStorage.removeItem('accesstoken');
      this.isUserLogged = false;
      this.userlogout.emit();
      this.iduser = '-1';
    }
  }
  /**
   * si verifica se l'utente ha effettuato il login
   */
  ctrLogIn() {
    this.isUserLogged = !!localStorage.getItem('token');
    if (this.isUserLogged) {
      let token = localStorage.getItem('token');
      let isExpired = this.helper.isTokenExpired(token);
      // console.log("expired token", isExpired);
      if(!isExpired){
        this.refreshToken().subscribe((payload: Jwt) => {
          this.savePayload(payload);
          this.emitLogin();
          this.iduser = localStorage.getItem('id');
        }, (httpResp: HttpErrorResponse) => {
          if(httpResp.status == 400){
            this.logout();
          }
        })
      } else {
        this.emitLogin();
        this.iduser = localStorage.getItem('id');
      }
    } else {
      // this.logout();
    }
    // return this.isUserLogged;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getLanguage() {
    return localStorage.getItem('locale') || 'it';
  }

  getIsAdmin() {
    return localStorage.getItem('role') === 'admin';
  }

  getIsSupervisor() {
    return localStorage.getItem('role') === 'supervisor';
  }

  getIdUser() {
    return localStorage.getItem('username');
  }

  getID(){
    return localStorage.getItem('id');
  }

  // socialLogin(email: string, displayName, accesstoken: string, domain: string) {
  /**
   * social login setta local storage con i dati passati da parametro
   * @param  {firebase.User} user
   * @param  {string} accesstoken
   * @param  {string} domain
   */
  socialLogin(user: any | firebase.User, accesstoken: string, domain: string) {
    this.http.post(environment.wmaiAPIServer + '/social/login',
      {
        userid: user.email || user.displayName,
        email: user.email || '',
        name: '',
        accesstoken,
        domain,
        lastname: '',
        firstname: '',
        suid: user.uid,
      }, 
      { }
    ).subscribe((payload: Jwt) => {
      if(payload.isactive){
        this.completeLogin(payload);
      } else {
        this.zone.run(() => {
          this.showSimpleModal('auth.messages.attention', 'auth.messages.user_not_activate')
        })
      }
    },
      (httpResp: HttpErrorResponse) => {
        if(httpResp.error.error){
          alert(httpResp.error.error);
        } else {
          alert("Si è verificato un'errore!\nRiprova tra qualche istante")
        }
        this.isUserLogged = false;
      },
    );
  }

  completeLogin(payload: Jwt){
    this.savePayload(payload);
    this.userislogin.emit({
      userid: payload.userid,
      token: payload.token,
      locale: payload.locale,
      email: payload.email,
      isactive: payload.isactive,
      isfirstlogin: payload.isfirstlogin,
      domain: payload.domain,
      accesstoken: payload.accesstoken
    });
    if (this.appservice.iAmMobile()) {
      this.saveDeviceId();
    }
    this.isUserLogged = true;
    this.isFirstLogin = Boolean(payload.isfirstlogin);
    this.userisfirstlogin.emit(Boolean(payload.isfirstlogin));
    this.zone.run(() => {
      if (this.isFirstLogin) {
        this.router.navigate(['/settings/', localStorage.getItem('username')]);
      } else {
        this.router.navigate(['/']);
      }
    });
  }

  savePayload(payload: Jwt){
    localStorage.setItem('token', payload.token);
    localStorage.setItem('email', payload.email);
    localStorage.setItem('username', payload.userid);
    localStorage.setItem('locale', payload.locale);
    localStorage.setItem('id', payload.__id);
    this.iduser = payload.__id;
    this.appservice.changeCurrentLanguage.emit(payload.locale);
    localStorage.setItem('role', payload.user_role);
    localStorage.setItem('isfirstlogin', payload.isfirstlogin);
    localStorage.setItem('isactive', payload.isactive);
    localStorage.setItem('accesstoken', payload.accesstoken);
  }

  loginIdm(code) {

    const secret: any = 'Basic ' + btoa(environment.authEndPoint.client_id + ':' + environment.authEndPoint.client_secret);
    const headers = new HttpHeaders({
      Accept:  'application/json, application/x-www-form-urlencoded',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
      Authorization: secret
    });
    this.http.post(environment.authEndPoint.access_token_uri + '?code=' + code + '&client_id=' + environment.authEndPoint.client_id + '&client_secret=' + environment.authEndPoint.client_secret +
      '&scope=read&grant_type=' + environment.authEndPoint.grant_type  + '&redirect_uri=' + environment.authEndPoint.responseUrl
      , null,  {
        headers: new HttpHeaders({
          Accept:  'application/json, application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
          Authorization: secret
        })
      }
    ).subscribe((token: any) => {
      const bearer: any = 'Bearer ' + token.access_token;
      this.http.post(environment.authEndPoint.host + '/SSOServiceOAuth2'
        , null, {
        // tslint:disable-next-line: max-line-length
        headers: new HttpHeaders({
          Accept:  'application/json, application/x-www-form-urlencoded',
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache',
          // tslint:disable-next-line: max-line-length
          // 'Access-Control-Request-Headers': 'access-control-allow-credentials,access-control-allow-headers,access-control-allow-methods,access-control-allow-origin,authorization,cache-control,content-type',
          // 'Referer': 'https://intenseweb.sardegnaturismo.it/?code=' + code,
          // 'Origin': 'https://intenseweb.sardegnaturismo.it',
          Authorization: bearer
        })
      }
      ).subscribe((data: any) => {
        this.spidLogin(data.attributeMap.email, token.access_token, 'social');
      });
    });
  }

  spidLogin(userid: string, accesstoken: string, domain: string = 'social') {
    this.http.post(environment.wmaiAPIServer + '/spid/login',
      {
        userid: userid,
        email: userid,
        name: '',
        accesstoken,
        domain,
        lastname: '',
        firstname: '',
      }, {
      headers:
        { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' },
    }
    ).subscribe((payload: Jwt) => {
      if(payload.isactive){
        this.completeLogin(payload);
      } else {
        this.zone.run(() => {
          this.showSimpleModal('auth.messages.attention', 'auth.messages.user_not_activate')
        })
      }
    },
      (httpResp: HttpErrorResponse) => {
        alert(httpResp.error.error);
        this.isUserLogged = false;
      },
    );
  }

  saveDeviceId() {
    FirebasePlugin.hasPermission(hasPermission => {
      if (hasPermission) {
        FirebasePlugin.getToken(token => {
          // save this server-side and use it to push notifications to this device
          this.wmaiservice.addDevice(token).subscribe(data => {
          });
          // if (environment.production === false) console.log(token);
        }, function (err) {
          Sentry.captureException(err);
        });

      }
    });
  }

  spidLogout(accesstoken: string) {
    const bearer: any = 'Bearer ' + accesstoken;
    this.http.post(environment.authEndPoint.host + '/revoke-token'
    , null, {
    // tslint:disable-next-line: max-line-length
    headers: new HttpHeaders({
      Accept:  'application/json, application/x-www-form-urlencoded',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache',
      Authorization: bearer,
    })
  }
  ).subscribe(data => {}, err => { 
    // if (environment.production === false) console.log(err); 
    Sentry.captureException(err);
    });
  }

  socialLogout(){
    TwitterConnect.logout(() => {}, (err) => {Sentry.captureException(err);});
    facebookConnectPlugin.logout(() => { }, (err) => {Sentry.captureException(err);});
    (<any>window).plugins.googleplus.logout((err) => {Sentry.captureException(err);});
  }

  showSimpleModal(title: string, content: string){
    let titlec: string = this.translateService.instant(title);
    let contentc: string = this.translateService.instant(content);
    this.modalService
      .open(new SimpleModal(titlec, contentc, ModalSize.Tiny))
      .onApprove(() => {
      })
  }

  refreshToken(){
    return this.http.post(environment.wmaiAPIServer + '/admin/refresh', {token: localStorage.getItem('token')});
  }

  emitLogin(){
    this.userislogin.emit(
      {
        userid: localStorage.getItem('username'),
        token: localStorage.getItem('token'),
        locale: localStorage.getItem('locale'),
        email: localStorage.getItem('email'),
        isactive: localStorage.getItem('isactive'),
        isfirstlogin: localStorage.getItem('isfirstlogin'),
        domain: localStorage.getItem('domain'),
        accesstoken: localStorage.getItem('accesstoken')
      }
    );
  }
}